import {Routes} from '@angular/router';
import {MainLayoutComponent} from './core/layout/main-layout/main-layout.component';
import {NotFoundPage} from './shared/common/pages/not-found/not-found.page';

export const APP_ROUTES: Routes = [
	{
		path: 'platforms',
		component: MainLayoutComponent,
		loadChildren: () => import('./features/platform/platform.route').then(m => m.PLATFORM_ROUTE)
	},
	{
		path: '404-not-found',
		component: NotFoundPage
	},
	{
		path: '**',
		redirectTo: '404-not-found'
	},
];
